import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Admin from "Containers/Admins";
import SignIn from "Containers/Login";
import Patients from "Containers/Patients";
import Provider from "Containers/Providers";
import ProtectedRoute from "ProtectedRoutes";
import { AdminProvider } from "Context/Admin";
import { LoginProvider } from "Context/Login";
import { TokenProvider } from "Context/Global";
import { Dashboard } from "Containers/Dashboard";
import { PatientProvider } from "Context/Patient";
import { GetToken } from "Constants/LocalStorage";
import { MEMBERSHIP_PLANS, PATIENT_MEMBERSHIPS_PATH } from "Constants/Views";
import { DoctorsProvider } from "Context/Provider";
import { ProviderForm } from "Context/ProviderForm";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { OperationsDashboard } from "Pages/Operations/OperationsDashboard";
import { EmailsPage } from "Pages/Emails/EmailsPage";
import { EmailCampaignDetail } from "Pages/Emails/EmailCampaignDetail";
import { MedConditionsNames } from "Containers/MedicalConditionsNames/MedConditionsNames";
import "./App.css";
import { IntakeFormContainer } from "Containers/IntakeForms/IntakeFormContainer";
import { ConversionsMainPage } from "Pages/Conversions/MainPage/MainPage";
import VisitTypes from "Containers/VisitTypes";
import { MailOrderPharmacies } from "Pages/MailOrderPharmacies/MailOrderPharmacies";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

function App() {
  const isAuthenticated = GetToken();
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <TokenProvider>
          <Switch>
            <ProtectedRoute path="/dashboard" component={() => <Dashboard />} />
            <ProtectedRoute
              path="/operations"
              component={() => <OperationsDashboard />}
            />
            <ProtectedRoute
              exact
              path="/emails"
              component={() => <EmailsPage />}
            />
            <ProtectedRoute
              path="/emails/:id"
              component={() => <EmailCampaignDetail />}
            />
            <ProtectedRoute
              path="/intakeForms"
              component={() => <IntakeFormContainer />}
            />
            <ProtectedRoute
              path="/visitTypes"
              component={() => <VisitTypes />}
            />
            <ProtectedRoute
              path="/conversions"
              component={() => <ConversionsMainPage />}
            />
            <ProtectedRoute path="/mailOrderPharmacies" component={() => <MailOrderPharmacies />} />

            <ProtectedRoute
              path="/provider"
              component={() => (
                <DoctorsProvider>
                  <ProviderForm>
                    <Provider />
                  </ProviderForm>
                </DoctorsProvider>
              )}
            />
            <ProtectedRoute
              path="/patient"
              component={() => (
                <PatientProvider>
                  <Patients />
                </PatientProvider>
              )}
            />

            <ProtectedRoute
              path="/meds"
              component={() => <MedConditionsNames />}
            />
            <ProtectedRoute
              path="/admin"
              component={() => (
                <AdminProvider>
                  <Admin />
                </AdminProvider>
              )}
            />

            <Route
              exact
              path="/"
              render={() =>
                isAuthenticated ? (
                  <Dashboard />
                ) : (
                  <LoginProvider>
                    <SignIn />
                  </LoginProvider>
                )
              }
            />
            <Redirect from="*" to="/" />
          </Switch>
        </TokenProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
